export { default } from './wistia-modal';
export { default as wistiaModalConfig } from './wistia-modal.config';
